export default {
  RESUME: {
    layout: {
      isCompleted: false,
    },
    workExperience: {
      isCompleted: false,
    },
    skills: {
      isCompleted: false,
    },
    wiseRef: {
      isCompleted: false,
    },
  },
  COVER_LETTER: {
    layout: {
      isCompleted: false,
    },
  },
};
